// The could-help matching query's function reference (bead hf-e5-availability-ccp.2).
//
// One query, no mutations. This surface SUGGESTS; it never acts. The only action it
// offers — "Ask [name]" — creates a Direct Request, and that mutation belongs to
// `hf-e6-commitments-coverage-udt.1`, so there is deliberately nothing here to call.
//
// WHY THE TYPE COMES FROM THE GENERATED API rather than from `@herefor/contracts`.
// `contracts.MatchCandidate` currently describes a narrower shape than
// `convex/domain/availability.ts:matchesForNeed` actually returns — it has the person
// and the window id, but not the window's own times, the provenance, or `recordedAt`,
// all of which the handler returns and this surface needs. Rather than edit another
// agent's contract mid-flight, this follows `apps/web/src/convex/plan.ts` and infers
// from the generated types, which cannot drift from the backend by construction. The
// drift itself is worth closing; it is noted on the bead for whoever owns Epic 5.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const matchingQueries = {
  /** Who could help with one need — containment, mode and conflict, per the kernel. */
  matchesForNeed: api.domain.availability.matchesForNeed,
} as const;

export type MatchesForNeedResult = FunctionReturnType<typeof matchingQueries.matchesForNeed>;
export type MatchCandidate = MatchesForNeedResult[number];
